"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WEB_ELEMENTS_VERSION = exports.USER_AGENT_HEADER = exports.USER_AGENT_CLIENT = exports.MERGE_CONTENT_TYPE = exports.DEFAULT_ELEMENTS_BASE_URL = exports.DEFAULT_BASE_URL = exports.DD_TOKEN = exports.DD_GIT_SHA = exports.CONTENT_TYPE_HEADER = exports.CLIENT_USER_AGENT_HEADER = exports.CLIENT_BASE_PATHS = exports.CF_RAY_HEADER = exports.BT_TRACE_ID_HEADER = exports.BT_IDEMPOTENCY_KEY_HEADER = exports.BT_EXPOSE_PROXY_RESPONSE_HEADER = exports.BROWSER_LIST = exports.API_KEY_HEADER = void 0;
const WEB_ELEMENTS_VERSION = '1.7.2';
exports.WEB_ELEMENTS_VERSION = WEB_ELEMENTS_VERSION;
const API_KEY_HEADER = 'BT-API-KEY';
exports.API_KEY_HEADER = API_KEY_HEADER;
const BT_TRACE_ID_HEADER = 'bt-trace-id';
exports.BT_TRACE_ID_HEADER = BT_TRACE_ID_HEADER;
const CF_RAY_HEADER = 'cf-ray';
exports.CF_RAY_HEADER = CF_RAY_HEADER;
const BT_IDEMPOTENCY_KEY_HEADER = 'bt-idempotency-key';
exports.BT_IDEMPOTENCY_KEY_HEADER = BT_IDEMPOTENCY_KEY_HEADER;
const BT_EXPOSE_PROXY_RESPONSE_HEADER = 'BT-EXPOSE-RAW-PROXY-RESPONSE';
exports.BT_EXPOSE_PROXY_RESPONSE_HEADER = BT_EXPOSE_PROXY_RESPONSE_HEADER;
const CONTENT_TYPE_HEADER = 'Content-Type';
exports.CONTENT_TYPE_HEADER = CONTENT_TYPE_HEADER;
const MERGE_CONTENT_TYPE = 'application/merge-patch+json';
exports.MERGE_CONTENT_TYPE = MERGE_CONTENT_TYPE;
const USER_AGENT_HEADER = 'User-Agent';
exports.USER_AGENT_HEADER = USER_AGENT_HEADER;
const CLIENT_USER_AGENT_HEADER = 'BT-CLIENT-USER-AGENT';
exports.CLIENT_USER_AGENT_HEADER = CLIENT_USER_AGENT_HEADER;
const USER_AGENT_CLIENT = 'BasisTheoryJS';
exports.USER_AGENT_CLIENT = USER_AGENT_CLIENT;
const DEFAULT_BASE_URL = `https://${"api.basistheory.com"}`;
exports.DEFAULT_BASE_URL = DEFAULT_BASE_URL;
const DEFAULT_ELEMENTS_BASE_URL = `https://${"js.basistheory.com/hosted-elements"}`;
exports.DEFAULT_ELEMENTS_BASE_URL = DEFAULT_ELEMENTS_BASE_URL;
const DD_TOKEN = "pub5f53501515584007899577554c4aeda6";
exports.DD_TOKEN = DD_TOKEN;
const DD_GIT_SHA = "b862d8e634020f77c61023ffeee4f0e01c36e871";
exports.DD_GIT_SHA = DD_GIT_SHA;
const CLIENT_BASE_PATHS = {
  tokens: 'tokens',
  tokenize: 'tokenize',
  applications: 'applications',
  applicationKeys: 'applications',
  applicationTemplates: 'application-templates',
  tenants: 'tenants/self',
  logs: 'logs',
  reactorFormulas: 'reactor-formulas',
  reactors: 'reactors',
  permissions: 'permissions',
  proxies: 'proxies',
  proxy: 'proxy',
  sessions: 'sessions',
  threeds: '3ds',
  tokenIntents: 'token-intents'
};
exports.CLIENT_BASE_PATHS = CLIENT_BASE_PATHS;
const BROWSER_LIST = [{
  browserName: 'Firefox',
  browserUA: 'Firefox'
}, {
  browserName: 'SamsungBrowser',
  browserUA: 'SamsungBrowser'
}, {
  browserName: 'Opera',
  browserUA: 'Opera'
}, {
  browserName: 'Opera',
  browserUA: 'OPR'
}, {
  browserName: 'Microsoft Internet Explorer',
  browserUA: 'Trident'
}, {
  browserName: 'Microsoft Edge (Legacy)',
  browserUA: 'Edge'
}, {
  browserName: 'Microsoft Edge (Chromium)',
  browserUA: 'Edg'
}, {
  browserName: 'Google Chrome/Chromium',
  browserUA: 'Chrome'
}, {
  browserName: 'Safari',
  browserUA: 'Safari'
}];
exports.BROWSER_LIST = BROWSER_LIST;